import React, { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import route_map from "@/config/route_map";
// import IndexRC from '@/pages/index';
import ErrorBoundary from "@/components/ErrorBoundary.js";
import LayoutRC from "@/components/layout";
// import AppTVRC from '@/pages/app_tv'
// import Labs from "./pages/labs";
import PageLoading from "@/components/pageLoading";

const IndexRC = React.lazy(() => import("@/pages/index"));
const Labs = React.lazy(() => import("./pages/labs"));

const router = createBrowserRouter([
  {
    path: route_map.entry,
    element: <LayoutRC />,
    children: [
      {
        path: "/en-US",
        element: (
          <Suspense fallback={<PageLoading />}>
            <IndexRC />
          </Suspense>
        ),
      },
      {
        path: "/zh-CN",
        element: (
          <Suspense fallback={<PageLoading />}>
            <IndexRC />
          </Suspense>
        ),
      },
      {
        path: route_map.index,
        element: (
          <Suspense fallback={<PageLoading />}>
            <IndexRC />
          </Suspense>
        ),
      },
    ],
    errorElement: <ErrorBoundary />,
  },
  {
    path: route_map.labs,
    element: (
      <Suspense fallback={<PageLoading />}>
        <Labs />
      </Suspense>
    ),
  },
]);

export default router;
